export const SEARCH_SUCCESS = "SEARCH_SUCCESS";

export function searchSuccess(instrcns) {
  return {
    type: SEARCH_SUCCESS,
    instrcns,
  };
}
